module.exports = __webpack_public_path__ + "static/img/MitchellStarc.a1dca5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MitchellStarc.jpg
// module id = VlvR
// module chunks = 0